// extracted by mini-css-extract-plugin
export default {"footer_pcclink-list-item__icon":"footer_pcclink-list-item__icon_XR5D40DF","footer__social-links__placeholder":"footer__social-links__placeholder_hDZFaAJA"};